import { Backdrop, Box, CircularProgress, Modal } from "@mui/material";
import React, { useState, useEffect, useCallback, useRef,useMemo } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import _ from "lodash";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import AlertComponent from "../alert/alert";
import { rfqServices } from "../../services/rfqServices";
import Switch from "@mui/material/Switch";
import Tooltip from '@mui/material/Tooltip';
import {trimString } from "../../constant";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  height: "45rem",
  overflowY: "auto",
};
const extingvendormodalstyle1 = {
  position: "absolute",
  top: "55%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  // height: "33rem",
  overflowY: "auto",
};

const initialColumns = [
  { id: "vendorCode", label: "Vendor Code", isSort: true, sortLabel: "asc" },
  { id: "vendorName", label: "Vendor Name", isSort: true, sortLabel: "asc" },
  { id: "email", label: "Email", isSort: true, sortLabel: "asc" },
  { id: "userName", label: "User Name", isSort: true, sortLabel: "asc" },
  { id: "vendorType", label: "Category", isSort: true, sortLabel: "asc" },
  { id: "status", label: "Status", isSort: true, sortLabel: "asc" },
  { id: "deactivationReason", label: "Reason", isSort: true, sortLabel: "asc" },
];

const RfqExitingVendor = (props) => {
  const [filterText, setFilterText] = useState("");
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(initialColumns);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchFilter, setIsSearchFilter] = useState(false);
  const [isForMeChecked, setIsForMeChecked] = useState(false);
  const [requestPayload, setRequestPayload] = useState({
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  });
  const [loading, setLoading] = useState(false);
  const modalRef = useRef(null);

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };

  const getExistingVendorRfqList = (requestPayloadParam, filterTextParam) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    rfqServices
      .getExistingVendorRfqListing(param)
      .then((res) => {
        if (res && res.data) {
          // setexistingVendorDataList(res.data?.data);
          if (isSearchFilter) {
            setData((prevData) => [...res.data?.data?.vendors]);
          } else {
            // setData((prevData) => [...prevData, ...res.data?.data?.vendors]);
            setData((prevData) => [...res.data?.data?.vendors]);
          }
          setIsSearchFilter(false);
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'No Data Found', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLabel = sortOrder === "asc" ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLabel];
    requestPayloadInit.pageNumber = 1;
    columnsInit[index].sortLabel = newSortLabel;
    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  };

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  };

  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  };

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onFilterSubmit = () => {
    props.getExistingVendorRfqList(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
      setIsSearchFilter(true);
    }, 800),
    [requestPayload]
  );

  const fetchMoreData = () => {
    if (!loading) {
      setLoading(true);
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber += 1;
      props.getExistingVendorRfqList(requestPayloadInit, filterText);
      setRequestPayload(requestPayloadInit);
    }
  };

  // const handleScroll = (e) => {
  //   const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
  //   if (scrollTop + clientHeight >= scrollHeight) { 
  //     fetchMoreData();
  //   }

  // };

  const handleScroll = () => {

    if (modalRef.current.scrollTop + modalRef.current.clientHeight >= modalRef.current.scrollHeight) {
      setRequestPayload((prevData) => ({ ...prevData, pageNumber: prevData?.pageNumber + 1 }));
    }
  };



  useEffect(() => {
    if (props.existingVendor) {
      getExistingVendorRfqList(requestPayload, filterText);
      // modalRef?.current?.addEventListener('scroll', handleScroll);
      if (modalRef.current) {
        modalRef.current.addEventListener('scroll', handleScroll);
      }
    }
    return () => {
      setFilterText("");
      if (modalRef.current) {
        modalRef.current.removeEventListener('scroll', handleScroll);
      }
    };

  }, [requestPayload, props.existingVendor]);

  const currentPage = props?.vendorList?.data?.currentPage;

  const handleForMeToggle = (checked) => {
    setIsForMeChecked(checked);
  };
  // const getFilteredVendors = useMemo(() => {
  //   const selectedVendorIds = new Set(props.rfqVendorsIds.map((vendor) => vendor._id));  
  //   return data
  //     .filter((vendor) => 
  //       isForMeChecked
  //         ? selectedVendorIds.has(vendor._id) // Show selected vendors if isForMeChecked is true
  //         : !selectedVendorIds.has(vendor._id) // Show unselected vendors if isForMeChecked is false
  //     )
  //     .map((vendor) => ({
  //       ...vendor,
  //       ischecked: selectedVendorIds.has(vendor._id), // Add ischecked based on selectedVendorIds
  //     }));
  // }, [data, isForMeChecked, props.rfqVendorsIds]);

  const getFilteredVendors = useMemo(() => {
    const selectedVendorIds = new Set(props?.rfqVendorsIds?.map((vendor) => vendor._id)); // Use Set for quick lookup
  
    return data
      ?.filter((vendor) =>
        isForMeChecked
          ? selectedVendorIds.has(vendor._id) // Show selected vendors if isForMeChecked is true
          : !selectedVendorIds.has(vendor._id) // Show unselected vendors if isForMeChecked is false
      )
      ?.map((vendor) => ({
        ...vendor,
        ischecked: selectedVendorIds.has(vendor._id), // Add ischecked based on selectedVendorIds
      })) || []; // Fallback to an empty array if data is undefined
  }, [data, isForMeChecked, props.rfqVendorsIds]);

  return (<>
    <Modal
      open={props.existingVendor}
      onClose={props.closeExitingVendorRFQModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={extingvendormodalstyle1}
        className="modal_react_controlpanel_employee MuiBox-root rfq_react_existing_vendor_rowsew"
      // style={{ width: "45%" }}
      // onScroll={handleScroll}
      >
        <div className="modal-header">
          <h1 className="modal-title fs-5 create_rfq" id="exampleModalLabel">
            Existing Vendor
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            fdprocessedid="kum8iho"
            onClick={props.closeExitingVendorRFQModal}
          ></button>
        </div>
         <div>
  
          <div className="search_main" style={{ marginBottom: "10px",width:"100%", }}>
          <div id="custom-search-input" style={{ marginBottom: "10px",width:"39%" }}>
            <div className="input-group col-md-12">
              <input
                type="text"
                className="form-control input-lg"
                placeholder="Search here"
                fdprocessedid="8achb"
                onChange={onFilterTextChange}
                value={filterText}
              />
              <span className="input-group-btn">
                <button className="btn btn-info btn-lg" type="button" fdprocessedid="trsp06">
                  <span className="glyphicon glyphicon-search">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                    </svg>
                  </span>
                </button>
              </span>
            </div>
          </div>
          <div className="evaluation_perfomance_rate_fgdreact" style={{ width:"59%" ,paddingLeft:"10px"}}>
          <div className="create_listing_project_div_bcfr">
          <p>Non Selected Vendor</p>
            <Switch
              className="emp-ls-active-txt"
              checked={isForMeChecked}
              inputProps={{ "aria-label": "controlled" }}
              onChange={(e) => handleForMeToggle(e.target.checked)}
            />
           <p>Selected Vendor</p>
          </div>
        </div>
        </div>
        <div ref={modalRef} className="existing-rfq-box" onScroll={handleScroll} >
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div
                  className="listing_main listing_main_dragdropcontext_body"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <table className="dragdropcontext_ondragend_block_row">
                    <thead style={{ position: "sticky", top: "0", zIndex: 1 ,width:"100%"}}>
                      <tr>
                        <th className="vendor_tabels">
                          <input type="checkbox" />
                        </th>
                        {columns.map((column, index) => (
                          <Draggable key={column.id} draggableId={column.id} index={index}>
                            {(provided) => (
                              <th
                                className="vendor_tabels"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {column.isSort && (
                                  <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)}>
                                    <SwapVertIcon className="swap-sort-ico" />
                                  </span>
                                )}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {getFilteredVendors.length < 1 && (
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">
                            No Data Found
                          </td>
                        </tr>
                      )}
                      {getFilteredVendors.length > 0 &&
                        getFilteredVendors.map((row, rowIndex) => (
                          <tr key={rowIndex} className="maine_tr_vendor">
                            <td>
                            <input
                                type="checkbox"
                                value={row.ischecked}
                                  checked={props.selectedVendorIds[currentPage]?.has(row._id) || row.ischecked}
                                // checked={row.ischecked}
                               disabled= {row.status === false}
                                // onChange={(e) => props.onCheckboxChange(row._id, e.target.checked, currentPage)}
                                onChange={(e) => props.onCheckboxChange(row._id, e.target.checked, currentPage)}
                              />
                            </td>
                            {columns.map((column, index) => (
                              <td key={index}>
                                {column.id === "status" ? ( 
                                  <p className="" >
                                    {row[column.id] === false ? 'Deactive':'Active'}
                                  </p>
                                ) : (
                                  <Tooltip title={row[column.id]}>
                                    {row[column.id] ? trimString(row[column.id], 20) : ""}
                                  </Tooltip>
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
</div>
        <div className="exting_vendor_modarfq">
          <button
            type="button"
            className="btn btn-outline-secondary " style={{ borderRadius: "20px" }}
            data-dismiss="modal"
            fdprocessedid="3gp3uc"
            onClick={props.closeExitingVendorRFQModal}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-success save_next_btn"
            fdprocessedid="7mrm8"
            onClick={() => props.submitExistingVendorId(false)}
          >
            Add
          </button>
        </div>
      </Box>
    </Modal>

    <AlertComponent
      alertComponent={alertComponent}
      handleClose={handleCloseAlert}
    />

    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => 999999,//theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  </>
  );
};

export default RfqExitingVendor;